import { Skeleton, Theme, useMediaQuery } from '@mui/material';
import React, { FunctionComponent, useState } from 'react';
import { API } from '../../api/apiConstants';
import { PageColumn } from '../../core/formBuilder/usePages';
import ImageTextOverlayComponent from '../commons/ImageTextOverlayComponent';

interface ImageColumnProps {
  column: PageColumn;
}

const ImageColumn: FunctionComponent<ImageColumnProps> = ({ column }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const matchesTablet = useMediaQuery((theme: Theme) =>
    theme.breakpoints.between('xs', 'md')
  );

  return column?.desktopImage ? (
    <div
      style={{
        position: 'relative', // anchor for absolute overlay text
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <img
        src={API.V3.STATIC_RESOURCES.STATIC_RESOURCE(
          column?.desktopImage?.identifier
        )}
        alt={
          column.desktopImage?.informativeGraphic &&
          column.desktopImage.alt !== ''
            ? column.desktopImage.alt
            : ''
        }
        style={{
          objectFit: 'cover',
          overflow: 'hidden',
          height: '100vh',
          width: matchesTablet ? '33vw' : '50vw',
          maxWidth: matchesTablet ? '33vw' : '50vw',
          position: 'fixed',
          objectPosition:
            column.desktopImage?.style?.objectPosition ?? 'center top',
        }}
        onLoad={() => {
          setImageLoaded(true);
        }}
        hidden={!imageLoaded}
        tabIndex={
          column?.desktopImage?.informativeGraphic &&
          column?.desktopImage?.alt !== ''
            ? 0
            : -1
        }
      />

      {!imageLoaded && (
        <Skeleton
          variant="rectangular"
          style={{
            width: '50%',
            objectFit: 'cover',
            overflow: 'hidden',
            height: '100vh',
            position: 'fixed',
          }}
        ></Skeleton>
      )}
      {column?.desktopImage?.identifier && (
        <ImageTextOverlayComponent textOverlay={column.imageTextOverlay} />
      )}
    </div>
  ) : (
    <></>
  );
};

export default ImageColumn;
